import React from 'react';
import { Grid, Card, CardContent, Typography } from '@mui/material';

const TarjetaDosLineas = ({ titulo, valor }) => {
  return (
    <Grid item>
      <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" fontWeight="bold">
            {titulo}
          </Typography>
          <Typography variant="h6" gutterBottom align="right">
            {valor}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default TarjetaDosLineas;